module.exports = __webpack_public_path__ + "static/media/cakesoft.b97bfaa5.png";